
import { useContext } from 'react'
import FormInput from '../dashboardComponents/FormInput';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import FormAddImage from '../dashboardComponents/FormAddImage';
import CategoriesList from '../categories&products_form/CategoriesList';

export default function AddCategoryForm({website}) {
    const { handleAddCategory, categoryName, setCategoryName} = useContext(DashboardContext);
    
    return (
        <form dir='rtl' className='dashboardForm'>
            <h2>הוסף קטגוריה</h2>
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"שם הקטגוריה:"} id={"addProduct_category"} type={"text"} _value={categoryName.slice(0,40)} placeholder={"אנא בחר שם עבור הקטגוריה"} onChangeAction={(e) => setCategoryName(e.target.value)} required={true}/>
            <FormAddImage website={website} directory={"categories"} dynamicPath={"settings.categories"} isArray={true} _required={false} action={handleAddCategory} label={"הוסף תמונה"} text={"שמור"} type={"button"} _id={"category_image_uploader"} arrayField='imgURL' toUpdateDoc={false} inputResetAction={()=>{setCategoryName("")}}/>
            {website?.settings?.categories.length > 0 && <div className="categoriesList_container">
                <h2 dir='rtl'>רשימת הקטגוריות שלי</h2>
                <CategoriesList website={website}/>
            </div>
            }
        </form>
    )
}
